import Model, { attr, belongsTo } from '@ember-data/model';
import { isPresent } from '@ember/utils';

export default class UserDocumentAttachment extends Model {
  @belongsTo('user-document-template-attachment', { async: false, inverse: 'userDocumentAttachment' })
  userDocumentTemplateAttachment;
  @belongsTo('visitor-document', { async: false, inverse: 'userDocumentAttachments' }) visitorDocument;

  @attr('string') fileUrl;
  @attr('string') file;

  get hasValidAttributes() {
    if (this.isNew || this.hasDirtyAttributes) {
      return isPresent(this.file);
    }
    return isPresent(this.fileUrl);
  }
}
